<template>
  <div class="content">
    <div style="width:100%;height: 4rem;background-color: #fff;font-size: .3rem;">
      <el-row>
        <el-col :span="10" style="height: 1rem;line-height: 1rem;margin-left: .3rem">姓名：{{name}}</el-col>
        <el-col :span="10" style="height: 1rem;line-height: 1rem;">就诊卡号：{{$storage.get('patient').clinic_num?$storage.get('patient').clinic_num:'000000'}}</el-col>
      </el-row>
      <div style="width: 90%;margin: 0 auto;background-color: #FAFAD2;height: 1.2rem;border-radius: .1rem">
        <el-row>
          <el-col :span="12" style="height: .6rem;line-height: .6rem;margin-left: .3rem">住院号：{{zyh}}</el-col>
          <el-col :span="10" style="height: .6rem;line-height: .6rem;">住院天数：{{zyts}}天</el-col>
        </el-row>
        <div style="height: .6rem;line-height: .5rem;margin-left: .3rem">入院日期：{{zydate}}</div>
      </div>
      <div style="width: 90%;margin: .3rem auto;background-color: #FAFAD2;height: 1.2rem;border-radius: .1rem">
        <el-row>
          <el-col :span="12" style="height: .6rem;line-height: .6rem;margin-left: .3rem">预交金总额：{{yjamount}}</el-col>
          <el-col :span="10" style="height: .6rem;line-height: .6rem;">总费用：{{amount}}</el-col>
        </el-row>
        <div style="height: .6rem;line-height: .5rem;margin-left: .3rem;" :class="parseFloat(yjmoney)<0?'redC':''">预交金余额：{{yjmoney}}</div>
      </div>
    </div>
    <div style="width: 90%;height: 3rem;margin: .2rem auto;font-size: .3rem;background-color: #fff;">
      <div style="width: 90%;height: 2rem;margin: 0 auto;border-bottom: 1px #dddddd solid">
        <div style="line-height: .8rem;font-size: .28rem">请输入付款金额(元)</div>
        <div style="font-size: .4rem">
          ￥<input type="text" v-model="money" style="font-size: .8rem;width: 80%;height: .8rem;border: none;outline:none;"></input>
        </div>
      </div>
      <div style="width: 90%;height: 1rem;margin: 0 auto;line-height: 1rem;color: #8a8a8a;font-size: .28rem">
        输入金额应在<span style="color: #000">100</span>到<span style="color: #000">20000</span>之间
      </div>
    </div>
    <div style="width: 100%;text-align: center;">
      <el-button type="primary" style="width: 6rem;font-size: .32rem" @click="pay">立即支付</el-button>
    </div>
  </div>
</template>

<script>
  import { payzyfeelist_bypay_after, payzyfeelist, getzyfeelist} from '../../api/index'
  export default {
    data(){
      return{
        name:'',
        zyh:'',
        zyts:'',
        zydate:'',
        yjamount:'',
        amount:'',
        yjmoney:'',
        money:2000,
        yjdjh:'',
      }
    },
    created() {
      //修改标题
      document.title = '住院预缴款'
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      getzyfeelist({
        name:this.$storage.get('patient').clinic_patient_name,
        cardnum:this.$storage.get('patient').clinic_num,
        healthcardno:this.$storage.get('patient').healthCardId,
        patientid:this.$storage.get('patient').patient_id,
      }).then(res=>{
        loading.close();
        if(res.Data.length>0){
          this.name = res.Data[0].姓名
          this.zyh = res.Data[0].住院号
          this.zyts = res.Data[0].住院天数
          this.zydate = res.Data[0].入院日期
          this.yjamount = res.Data[0].预交金总额
          this.amount = res.Data[0].总费用
          this.yjmoney = res.Data[0].预交金余额
          this.yjdjh = res.Data[0].预交单据号
        }
      })
    },
    methods:{
      pay(){
        const self = this
        if(this.money<0 || this.money>20000 || !(/\d/.test(this.money))){
          this.$message({
            message: '支付金额应在100-20000之间！',
            type: 'error',
            duration:3000,
            center:true,
            offset:200
          })
          return
        }
        payzyfeelist({
          // order_id: "string",
          // create_time: "2020-07-08T00:41:53.105Z",
          hospitalization_num: this.zyh,
          nos: this.yjdjh,
          // order_time: "string",
          order_amount: this.money,
          // order_status: 0,
          patient_name: this.name,
          patient_phone: this.$storage.get('patient').phone,
          // pay_status: 0,
          // update_time: "2020-07-08T00:41:53.105Z",
          user_openid: this.$storage.get('patient').open_id,
          // out_trade_no: "string",
          clinic_card_num: this.$storage.get('patient').clinic_num,
          HealthCardId: this.$storage.get('patient').healthCardId,
          PatientId: this.$storage.get('patient').patient_id,
          unionid:this.$storage.get('unionid'),
          // his_returncode: "string",
          // his_returnmsg: "string"
        }).then(res=>{
          if(!res.IsSuccess){
            this.$message({
              message: res.Msg,
              type: 'error',
              duration:3000,
              center:true,
              offset:200
            });
          }else {
            //支付
            let wxJsonApiParam =  JSON.parse(res.Data.WxJsonData.wxJsonApiParam)
            let order_id = res.Data.RecoredID
            function onBridgeReady() {
              WeixinJSBridge.invoke(
                'getBrandWCPayRequest', wxJsonApiParam,
                function(res) {
                  if(res.err_msg == "get_brand_wcpay_request:ok") {
                    self.$message({
                      message: '支付成功！',
                      type: 'success',
                      duration:3000,
                      center:true,
                      offset:200
                    });
                    // payzyfeelist_bypay_after({
                    //   order_id:order_id,
                    //   paystatus:1,
                    //   openid:self.$storage.get('openid')
                    // }).then(res=>{
                    //
                    // })
                    setTimeout(() => {
                      self.$router.push({path:'/hospitalInfo'})
                    }, 500)
                  }else {
                    self.$message({
                      message: '支付失败！',
                      type: 'error',
                      duration:3000,
                      center:true,
                      offset:200
                    });
                    // payzyfeelist_bypay_after({
                    //   order_id:order_id,
                    //   paystatus:2,
                    //   openid:self.$storage.get('openid')
                    // }).then(res=>{
                    //
                    // })
                  }
                }
              );
            }
            if(typeof WeixinJSBridge == "undefined") {
              if(document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
              } else if(document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
                document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
              }
            } else {
              onBridgeReady();
            }
          }
        })
      }
    }
  }
</script>

<style scoped>
  .content{
    width: 100%;
    height: 100vh;
    background-color: #f5f5f5;
  }
  .redC{
    color: red;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/hospitalPay.vue